module.exports = __webpack_public_path__ + "bd2e2989667691cf72d4e28a80c78a70.png";